import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 31 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.78155 20.01L1.75275 9.85923C1.74675 7.60083 3.19995 5.93043 5.36715 6.29523C5.79555 6.36723 6.49755 6.58923 6.86715 6.78723L8.89635 7.87323L12.7964 2.95683C13.451 2.13169 14.4467 1.6507 15.5 1.6507C16.5532 1.6507 17.5489 2.13169 18.2036 2.95683L26.3276 13.2C28.2477 15.5272 29.2986 18.4498 29.3 21.4668C29.3 28.8408 23.1116 34.8 15.5 34.8C7.88835 34.8 1.69995 28.8408 1.69995 21.4668C1.69995 20.9772 1.72755 20.4912 1.78155 20.01Z",
      fill: "#FA8E42",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.3144 20.4924C11.3317 20.4481 11.3547 20.4061 11.3828 20.3676L14.5628 16.0368C14.7717 15.7521 15.1037 15.5839 15.4568 15.5839C15.8099 15.5839 16.1419 15.7521 16.3508 16.0368L19.3784 20.16C20.3494 21.1138 20.8975 22.417 20.9 23.778C20.9 26.6496 18.482 28.9776 15.5 28.9776C12.518 28.9776 10.1 26.6496 10.1 23.778C10.1 22.5312 10.556 21.3876 11.3144 20.4924Z",
      fill: "#FFC800"
    }, null, -1)
  ])))
}
export default { render: render }